import { Navigate } from 'react-router-dom';
import { useAppContext } from '../Context/AppContext';
import { useFeature } from '../Hooks/useFeature';
import { getAuthenticatedHomePath } from '../Shared/homePath';

const UsersRoute = ({ children }) => {
	const { state } = useAppContext();
	const hasTeamAccounts = useFeature('team_accounts');
	const isSuperuser = Boolean(state.user.isSuperuser);
	const isManager = state.user.role === 'Manager' || isSuperuser;

	if (!state.user.id) {
		return null;
	}

	if (isSuperuser || (isManager && hasTeamAccounts)) {
		return children;
	}

	return <Navigate to={getAuthenticatedHomePath(state.user)} replace />;
};

export default UsersRoute;
